/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useMutation } from 'react-query'

import { recalculateLedgerV1 } from '@modules/billing-api/v1/callers'
import type { operations } from '@modules/billing-api/v1/types'

const useRecalculateLedger = () =>
  useMutation({
    mutationFn: (args: {
      pathParameters: operations['recalculateLedgerV1']['parameters']['path']
      body: operations['recalculateLedgerV1']['requestBody']['content']['application/json']
    }) => recalculateLedgerV1(args),
  })

export default useRecalculateLedger
